import { Contract, Person, PersonSurveySend, SurveyPerson } from "types";
import { GridSelectionModel } from "@mui/x-data-grid";
import uniqBy from "lodash/uniqBy";
import dayjs from "dayjs";

export const dataGridMapper = (persons: Person[]): Person[] =>
  persons?.map((person: Person, index: number) => ({
    ...person,
    id: `${index}/${person.personId}`,
    updatedDate: dayjs(person.updatedDate).format("YYYY-MM-DD"),
  })) ?? [];

export const personSurveySendMapper = (persons: Person[], surveyURL: string): PersonSurveySend => ({
  surveyURL,
  listTo:
    persons?.map(
      (person: Person): Person => ({
        personId: person?.personId,
        fullName: person?.fullName,
        phone: person?.phone,
        eMail: person?.eMail,
      })
    ) ?? [],
});

export const getPersonsByIdsArray = (person: Person[], businessIds: GridSelectionModel): Person[] => {
  const businessIdsValidated = businessIds?.map((id: any) => id?.split("/")[1]) ?? [];
  const personArray = person.filter((person) => businessIdsValidated.includes(person.personId)) ?? [];
  return uniqBy(personArray, "personId");
};

export const getApiResponse = (response: any, error: boolean): any => {
  if (error) {
    return response?.description;
  }
  return response?.data?.description || response?.data || response;
};

/**
 * It takes an array of contracts and returns an array of contracts with a new property called
 * canDelete set to false since contracts came from the API can't be deleted.
 * @param {Contract[]} contract - Contract[] - this is the array of contracts that we are mapping
 */
const contractMapper = (contract: Contract[]): Contract[] =>
  contract?.map((contract) => ({ ...contract, canDelete: false }));

export const personSurveyReceivedMapper = (person: any): SurveyPerson => {
  const personReceivedMapped = {
    identificationTypeId: person?.identificationTypeId,
    identificationNumber: person?.identificationNumber,
    personNames: person?.personNames,
    personLastName: person?.personLastName,
    email: person?.email,
    phone: {
      value: person?.phone || "",
      dialCode: "+57",
    },
    ccfId: person?.ccfId,
    afpId: person?.afpId,
    fcesId: person?.fcesId,
    epsId: person?.epsId,
    userCreation: person?.userCreation,
    updatedBy: person?.updatedBy,
    contracts: contractMapper(person?.contracts) ?? [],
  };
  return personReceivedMapped;
};
